module.exports = __webpack_public_path__ + "assets/img/serve-promise.8e2f30ea.png";